import { useEffect } from 'react';
import { Dropdown, Menu } from 'antd'
import { v4 as uuid } from "uuid"
import styled from '@emotion/styled'
import { SettingOutlined } from '@ant-design/icons'

export const OperationList = (props) => {
    const { rIndex, cIndex, item, formItems, setFormItems } = props

    const list = [...item.children];

    // 更新表格数据
    function onSetFormItems(type) {
        list.forEach((columns, r) => {
            // let 
            columns.forEach((item, c) => {
                if (!item.merge) {
                    // item.colPindex = cIndex + item.colspan
                    item.rightDisabled = getDisabledCol(list, r, c)
                    item.downDisabled = getDisabledRow(list, r, c)
                    item.splitColumnDisabled = item.colspan === 1
                    item.splitRowDisabled = item.rowspan === 1
                    item.deleteColumnDisabled = item.colspan !== 1 || columns.length === 1
                    item.deleteRowDisabled = item.rowspan !== 1 || list.length === 1
                }

            })
        })

        item.props.rows = list.length;
        item.props.cols = list[0] ? list[0].length : 0;

        setFormItems(
            formItems.map((el) => {
                if (el.key !== item.key) return el

                const { props } = el
                return {
                    ...el,
                    props: {
                        ...props,
                        cols: list[0] ? list[0].length : 0,
                        rows: list.length,
                    },
                    children: list,
                }
            })
        )
    }

    /**
     * 向左或者向右插入列
     * */
    function onLeftAndRightInsertColumn(type) {
        const index = type === 'left' ? cIndex : cIndex + 1

        list.forEach((item) => {
            item.splice(index, 0, {
                ...tdData(),
            })
        })

        onSetFormItems()
    }

    /**
     * 向上或者向下插入
     * */
    function onUpAndDownInsertRow(type) {
        const index = type === 'up' ? rIndex : rIndex + 1;
        const newRows = [];
        for (let i = 0; i < item.props.cols; i++) {
            newRows.push(tdData());
        }
        list.splice(index, 0, newRows)
        onSetFormItems()
    }

    /**
     * 向右合并
     * */
    function onRightMerge() {
        const newColspan = list[rIndex][cIndex].colspan
        const index = newColspan + cIndex

        const nextItem = { ...list[rIndex][index] }

        list[rIndex][cIndex].colspan =
            newColspan + (nextItem ? nextItem.colspan : 1)

        // 移动内容
        const newChildren = nextItem.children.map(cItem => ({ ...cItem, key: uuid() }))
        list[rIndex][cIndex].children = [
            ...list[rIndex][cIndex].children,
            ...newChildren
        ].map((cItem, comI) => ({
            ...cItem,
            formItemProps: {
                ...cItem.formItemProps,
                name: `${item.formItemProps.name}_td_${rIndex}_${cIndex}_${comI}`,
            }
        }))

        for (let i = cIndex; i < list[rIndex][cIndex].colspan; i++) {
            list[rIndex][i].colMergeIndex = cIndex
        }

        list[rIndex].splice(index, 1, {
            merge: true,
            // 被行合并的索引
            rowMergeIndex: rIndex,
            colMergeIndex: cIndex,
        })

        onSetFormItems()
    }

    /**
     * 向下合并
     * */
    function onDwonMerge() {
        // 用展位行 + 当前选择的行
        const newRowspan = list[rIndex][cIndex].rowspan

        const index = newRowspan + rIndex

        const nextItem = list[index]

        list[rIndex][cIndex].rowspan =
            newRowspan + (nextItem ? nextItem[cIndex].rowspan : 1)

        // 移动内容
        const newChildren = nextItem[cIndex].children.map(cItem => ({ ...cItem, key: uuid() }))
        list[rIndex][cIndex].children = [
            ...list[rIndex][cIndex].children,
            ...newChildren
        ].map((cItem, comI) => ({
            ...cItem,
            formItemProps: {
                ...cItem.formItemProps,
                name: `${item.formItemProps.name}_td_${rIndex}_${cIndex}_${comI}`,
            }
        }))

        for (let i = rIndex; i < list[rIndex][cIndex].rowspan; i++) {
            list[i][cIndex].rowMergeIndex = rIndex
        }

        // 如果上一列是 2 下一列数据是1，需要特殊处理
        list[index].splice(cIndex, 1, {
            merge: true,
            rowMergeIndex: rIndex,
            colMergeIndex: cIndex,
        })



        onSetFormItems()
    }

    /**
     * 拆分成列
     */
    function onSplitColumn() {
        const colspanLength = cIndex + list[rIndex][cIndex].colspan

        for (let j = cIndex; j < colspanLength; j++) {
            if (list[rIndex][j].merge) {
                list[rIndex][j] = {
                    ...tdData(),
                    rowspan: list[rIndex][cIndex].rowspan,
                }
            }
        }

        list[rIndex][cIndex].colspan = 1

        onSetFormItems()
    }

    /**
     * 拆分成行
     */
    function onSplitRow() {
        const rowspanLength = rIndex + list[rIndex][cIndex].rowspan

        for (let i = rIndex; i < rowspanLength; i++) {
            if (list[i][cIndex].merge) {
                list[i][cIndex] = {
                    ...tdData(),
                    colspan: list[rIndex][cIndex].colspan,
                }
            }
        }

        list[rIndex][cIndex].rowspan = 1;

        onSetFormItems()
    }

    /**
     * 删除当前列
     * */
    function onDeleteColumn() {

        for (let i = 0; i < list.length; i++) {
            let delIndex = cIndex
            const item = list[i]

            // 当前被上一个合并
            if (item[cIndex].merge) {
                const index = item[cIndex].colMergeIndex
                item[index].colspan = item[index].colspan - 1
            }
            // 当前合并下一个
            else if (item[cIndex].colspan > 1) {
                item[cIndex].colspan = item[cIndex].colspan - 1
                delIndex = cIndex + 1
            }

            // 没有被合并 直接删除
            item.splice(delIndex, 1)
        }
        onSetFormItems()
    }

    /**
     * 删除当前行
     * */
    function onDeleteRow() {

        const data = list[rIndex]

        for (let i = 0; i < data.length; i++) {
            const item = data[i]
            // 当前被上一个合并
            if (item.merge) {
                const index = item.rowMergeIndex
                // 查询上一行
                list[index][i].rowspan = list[index][i].rowspan - 1
            }
            // 当前合并下一个, 需要把现在数据拷贝并且移动到下一个上
            else if (item.rowspan > 1) {
                list[rIndex + 1][i] = {
                    ...item,
                    rowspan: item.rowspan - 1,
                }
            }
        }

        list.splice(rIndex, 1)

        onSetFormItems()
    }

    // 操作栏增减栏列
    useEffect(() => {
        const rows = item.children.length;
        const cols = item.children[0]?.length || 0;

        // 最后一格
        if (rIndex !== rows - 1 || cIndex !== cols - 1) return;

        if (rows !== item.props.rows) {
            // 底部增加行
            if (item.props.rows > rows) {
                onUpAndDownInsertRow('down');
            }
            // 删除最后一行
            else {
                onDeleteRow();
            }
        } else if (cols !== item.props.cols) {
            // 最右侧增加列
            if (item.props.cols > cols) {
                onLeftAndRightInsertColumn('right');
            }
            // 删除最后一列
            else {
                onDeleteColumn();
            }
        }
    }, [item.props]); // eslint-disable-line


    /**
     * 向右合并( 如果是最后一个禁止，如果后面一个向下合并过禁止)
     * */
    const {
        rightDisabled,
        downDisabled,
        splitColumnDisabled,
        splitRowDisabled,
        deleteColumnDisabled,
        deleteRowDisabled
    } = list[rIndex][cIndex] || {}

    return (
        <Dropdown
            trigger="click"
            onVisibleChange={(val) => { }}
            overlay={
                <CustomMenu>
                    <Menu.Item
                        key="1"
                        onClick={onLeftAndRightInsertColumn.bind(null, 'left')}
                    >
                        左插入列
                    </Menu.Item>
                    <Menu.Item
                        key="2"
                        onClick={onLeftAndRightInsertColumn.bind(null, 'ringt')}
                    >
                        右插入列
                    </Menu.Item>
                    <Menu.Item
                        key="3"
                        onClick={onUpAndDownInsertRow.bind(null, 'up')}
                    >
                        上插入行
                    </Menu.Item>
                    <Menu.Item
                        key="4"
                        onClick={onUpAndDownInsertRow.bind(null, 'down')}
                    >
                        下插入行
                    </Menu.Item>
                    {/* <Divider style={{ margin: '5px 0' }} /> */}
                    <Menu.Item
                        key="5"
                        onClick={onRightMerge}
                        disabled={rightDisabled}
                    >
                        向右合并
                    </Menu.Item>
                    <Menu.Item
                        key="6"
                        onClick={onDwonMerge}
                        disabled={downDisabled}
                    >
                        向下合并
                    </Menu.Item>
                    {/* <Divider style={{ margin: '5px 0' }} /> */}
                    <Menu.Item
                        key="7"
                        onClick={onSplitColumn}
                        disabled={splitColumnDisabled}
                    >
                        拆分成列
                    </Menu.Item>
                    <Menu.Item
                        key="8"
                        onClick={onSplitRow}
                        disabled={splitRowDisabled}
                    >
                        拆分成行
                    </Menu.Item>
                    {/* <Divider style={{ margin: '5px 0' }} /> */}
                    <Menu.Item
                        key="9"
                        onClick={onDeleteColumn}
                        disabled={deleteColumnDisabled}
                    >
                        删除当前列
                    </Menu.Item>
                    <Menu.Item
                        key="10"
                        onClick={onDeleteRow}
                        disabled={deleteRowDisabled}
                    >
                        删除当前行
                    </Menu.Item>
                </CustomMenu>
            }
            placement="bottomLeft"
        >
            <div
                className={`td-setting-btn td-setting`}
                onClick={(e) => e.stopPropagation()}
            >
                <SettingOutlined />
            </div>
        </Dropdown>
    )
}


const tdData = () => ({
    // 列合并参数
    colspan: 1,
    // 行合并参数
    rowspan: 1,
    // 单元格内控件列表
    children: [],
})
/**
 * 1.本身合并过，下一个没有合并，向下合并禁止
 * 2.本身没有合并，下一个合并，向下合并禁止
 * 3.都合并了，合并的栏也是一样 ，可以合并
 * */
function getDisabledCol(rows, rIndex, cIndex) {
    // 是最后一列
    // 自己向下合并，下一个没有合并
    // 自己没有合并， 下一个栏目合并
    const cols = rows[rIndex]
    const item = cols[cIndex]

    const index = item.colspan + cIndex
    // 由于数组中用null站位 所以需要排除掉null
    // const length = cols.filter((item) => !!item).length;

    // console.log(rows, rIndex, cIndex)
    // 下一个是不存在
    if (!cols[index]) {
        return true
    }

    if (cIndex === cols.length - 1) {
        return true
    }

    if (cols[index]) {
        // 自己向下合并，下一栏没有合并
        // 判断当前栏 与下一列是否一致， 一致可以合并
        if (item.rowspan === cols[index].rowspan) {
            return false
        } else {
            return true
        }
    }

    return false
}

function getDisabledRow(rows, rIndex, colIndex) {
    // 是最后一列
    // 自己向下合并，下一个没有合并
    // 自己没有合并， 下一个栏目合并

    // 获取当前的栏
    const curItem = rows[rIndex][colIndex]

    const index = curItem.rowspan + rIndex

    const cols = rows[index]

    if (!cols || !cols[colIndex]) {
        return true
    }

    if (index === rows.length) {
        return true
    }
    // 下一个是否有值
    if (cols && cols[colIndex]) {
        // 自己向下合并，下一栏没有合并
        // 判断当前栏 与下一列是否一致， 一致可以合并

        if (cols[colIndex].colspan === curItem.colspan) {
            return false
        } else {
            return true
        }
    }

    return false
}

const CustomMenu = styled(Menu)`
    .ant-menu-item {
        height: 27px;
        line-height: 27px;
        margin: 0px !important;
    }
`
